// pages/product/supplier/import.jsx
import { useState } from "react"
import { Modal } from "components"
import axios from "axios"
import nProgress from "nprogress"
import toast from "react-hot-toast"
import { lang } from "config"

const Content = ({ onSuccess }) => {
    const [file, setFile] = useState(null)
    const [errorMessages, setErrorMessages] = useState([])
    const [submitting, setSubmitting] = useState(false)

    const handleSubmit = async (e) => {
        e.preventDefault()

        if (!file) {
            toast.error("Silakan pilih file Excel terlebih dahulu")
            return
        }

        const url = `${process.env.REACT_APP_INVENTORY_API_URL}/product/model/import`

        const formData = new FormData()
        formData.append("file_upload", file)

        nProgress.start()
        setSubmitting(true)

        try {
            const response = await axios.post(url, formData, {
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            })

            // kalau backend kirim message
            toast.success(
                response?.data?.message ||
                    "Import product supplier berhasil diproses"
            )

            setErrorMessages([])
            if (onSuccess) {
                onSuccess()
            }
        } catch (error) {
            const status = error?.response?.status

            if (status === 422) {
                const data = error.response.data
                // backend kita tadi bentuknya:
                // { message: 'Validasi gagal.', errors: [ 'Row 2: ...', 'Row 5: ...' ] }
                const errs = Array.isArray(data?.errors)
                    ? data.errors
                    : typeof data?.errors === "object"
                    ? Object.values(data.errors).flat()
                    : [data?.message || "Validasi gagal."]

                setErrorMessages(errs.filter(Boolean))

                toast.error(data?.message || "Validasi gagal")
            } else {
                toast.error(
                    error?.response?.data?.message ||
                        "Gagal meng-import product supplier"
                )
            }
        } finally {
            nProgress.done()
            setSubmitting(false)
        }
    }

    return (
        <form onSubmit={handleSubmit} className="mt-6 space-y-6 text-xs">
            <div className="space-y-2">
                <p className="text-sm text-neutral-700">
                    Upload file Excel dengan format:
                </p>
                <ul className="pl-5 space-y-1 list-disc text-[11px] text-neutral-600">
                    <li>
                        Header baris pertama minimal:
                        <code className="px-1 mx-1 rounded bg-neutral-100">
                            Model
                        </code>
                        ,
                        <code className="px-1 mx-1 rounded bg-neutral-100">
                            Description
                        </code>
                        ,
                        <code className="px-1 mx-1 rounded bg-neutral-100">
                            SKU
                        </code>
                        ,
                        <code className="px-1 mx-1 rounded bg-neutral-100">
                            STOK
                        </code>
                        ,
                        <code className="px-1 mx-1 rounded bg-neutral-100">
                            HARGA
                        </code>
                        ,
                        <code className="px-1 mx-1 rounded bg-neutral-100">
                            BRG IP / LOKAL
                        </code>
                        ,
                        <code className="px-1 mx-1 rounded bg-neutral-100">
                            LOKASI
                        </code>
                        ,
                        <code className="px-1 mx-1 rounded bg-neutral-100">
                            berat/gram
                        </code>
                        ,
                        <code className="px-1 mx-1 rounded bg-neutral-100">
                            Brand
                        </code>
                        ,
                        <code className="px-1 mx-1 rounded bg-neutral-100">
                            Line
                        </code>
                        ,
                        <code className="px-1 mx-1 rounded bg-neutral-100">
                            Category
                        </code>
                        ,
                        <code className="px-1 mx-1 rounded bg-neutral-100">
                            Pre Order
                        </code>
                        ,
                        <code className="px-1 mx-1 rounded bg-neutral-100">
                            SATUAN
                        </code>
                        ,
                        <code className="px-1 mx-1 rounded bg-neutral-100">
                            MIN PEMBELIAN
                        </code>
                    </li>
                    <li>
                        <code className="px-1 mx-1 rounded bg-neutral-100">
                            Line
                        </code>{" "} Berisikan : Kacamata, Lensa, Accesories, Mesin
                    </li>
                </ul>
            </div>

            <div className="space-y-2">
                <label className="block text-xs font-medium text-neutral-700">
                    File Excel
                </label>
                <input
                    type="file"
                    accept=".xlsx,.xls"
                    onChange={(e) => {
                        const f = e.target.files?.[0]
                        setFile(f || null)
                        setErrorMessages([])
                    }}
                    className="block w-full text-xs text-neutral-700 border border-neutral-200 rounded-xl cursor-pointer file:mr-3 file:px-3 file:py-2 file:text-xs file:font-medium file:border-0 file:rounded-xl file:bg-neutral-800 file:text-white hover:file:bg-neutral-900"
                />
                {file && (
                    <p className="text-[11px] text-neutral-500">
                        Selected file: <span className="font-medium">{file.name}</span>
                    </p>
                )}
            </div>

            {errorMessages.length > 0 && (
                <div className="p-3 text-[11px] border rounded-xl border-red-200 bg-red-50 text-red-700 max-h-40 overflow-auto">
                    <div className="font-semibold mb-1">
                        {lang?.error || "Error"}:
                    </div>
                    <ul className="pl-4 space-y-1 list-disc">
                        {errorMessages.map((msg, idx) => (
                            <li key={idx}>{msg}</li>
                        ))}
                    </ul>
                </div>
            )}

            <div className="flex items-center space-x-2">
                <button
                    type="submit"
                    disabled={submitting}
                    className="items-center px-6 py-3 text-white transition bg-neutral-800 rounded-xl active:hover:scale-90 disabled:opacity-60"
                >
                    <span>
                        {submitting
                            ? "Meng-upload..."
                            : "Import Excel Product Supplier"}
                    </span>
                </button>
            </div>
        </form>
    )
}

const Import = ({ onSuccess }) => {
    const [isOpen, setIsOpen] = useState(false)

    const openModal = () => setIsOpen(true)
    const closeModal = () => setIsOpen(false)

    const handleSuccess = () => {
        closeModal()
        if (onSuccess) {
            onSuccess()
        }
    }

    return (
        <>
            <button
                type="button"
                onClick={openModal}
                className="inline-flex items-center px-4 py-3 space-x-2 text-xs transition border border-neutral-200 bg-neutral-50 rounded-xl active:hover:scale-90"
            >
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="w-4 h-4"
                    width={24}
                    height={24}
                    viewBox="0 0 24 24"
                    strokeWidth={1}
                    stroke="currentColor"
                    fill="none"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path
                        stroke="none"
                        d="M0 0h24v24H0z"
                        fill="none"
                    ></path>
                    <path d="M4 4h16v4h-16z" />
                    <path d="M4 12h16v8h-16z" />
                    <path d="M10 8v8l3 -3l3 3v-8" />
                </svg>
                <span>Import Excel</span>
            </button>

            <Modal
                isOpen={isOpen}
                onClose={closeModal}
                title="Import Product Supplier"
                content={<Content onSuccess={handleSuccess} />}
            />
        </>
    )
}

export default Import
